export const appHead = {"meta":[{"charset":"utf-8"},{"key":"robots","name":"robots","content":"max-image-preview:large"},{"key":"Accept-CH","http-equiv":"Accept-CH","content":"DPR, Viewport-Width, Width, ECT"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google","content":"notranslate"},{"name":"application-name","content":"Pitchup.com"},{"name":"apple-mobile-web-app-title","content":"Pitchup.com"},{"name":"theme-color","content":"#238338"},{"name":"format-detection","content":"telephone=no"},{"name":"alfred-version","content":"alfred@v4.46.126+85458"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Pitchup.com"},{"key":"og:url","property":"og:url","content":"https://www.pitchup.com"},{"property":"fb:app_id","content":"127689162592"},{"name":"twitter:card","content":"summary"},{"name":"twitter:site","content":"@pitchup"},{"key":"og:image","property":"og:image","content":"https://www.pitchup.com/app-icons/pitchup_logo_og.png"},{"key":"og:image:width","property":"og:image:width","content":"1200"},{"key":"og:image:height","property":"og:image:height","content":"630"}],"link":[{"key":"preconnect-cdn-cookieyes","rel":"preconnect","href":"https://cdn-cookieyes.com"},{"key":"dns-prefetch-cdn-cookieyes","rel":"dns-prefetch","href":"https://cdn-cookieyes.com"},{"key":"dns-prefetch-directory-cookieyes","rel":"dns-prefetch","href":"https://directory.cookieyes.com"},{"key":"preconnect-log-cookieyes","rel":"preconnect","href":"https://log.cookieyes.com"},{"key":"dns-prefetch-log-cookieyes","rel":"dns-prefetch","href":"https://log.cookieyes.com"},{"key":"dns-prefetch-speedcurve","rel":"dns-prefetch","href":"https://cdn.speedcurve.com"},{"rel":"icon","type":"image/x-icon","href":"https://www.pitchup.com/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://www.pitchup.com/app-icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://www.pitchup.com/app-icons/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"180x180","href":"https://www.pitchup.com/app-icons/favicon-180x180.png"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"append","prefetch":true,"componentName":"NuxtLink","prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false